import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { Cart } from '@grandvisionhq/carts-v2';
import { Card } from '@grandvisionhq/common';
import { Heading, Text } from '@grandvisionhq/elements';
import { PaypalOrderButton } from '@grandvisionhq/payments';
import { useBaseSummarySlot } from '../slots/summaries/summary-context.js';

const ExpressOverview = ({ addresses , contactDetails , shippingMethodInfo , labels , isUpdating , onNextClick ,  })=>{
    const { Slots  } = useBaseSummarySlot();
    const AddressesSummarySlot = Slots.addresses;
    const ContactDetailsSummarySlot = Slots.contactDetails;
    return /*#__PURE__*/ React__default.createElement("div", {
        className: "express-overview"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "express-overview__details"
    }, /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "smallest",
        component: "h2"
    }, labels.yourDetails), /*#__PURE__*/ React__default.createElement(Card, null, /*#__PURE__*/ React__default.createElement(Card.Content, null, /*#__PURE__*/ React__default.createElement(Card.Text, {
        variant: "body-head"
    }, labels.completed.shipmentDetailsDelivery), /*#__PURE__*/ React__default.createElement(Card.Text, null, shippingMethodInfo))), AddressesSummarySlot && /*#__PURE__*/ React__default.createElement(AddressesSummarySlot, swcHelpers.extends({}, addresses)), ContactDetailsSummarySlot && /*#__PURE__*/ React__default.createElement(ContactDetailsSummarySlot, swcHelpers.extends({}, contactDetails))), /*#__PURE__*/ React__default.createElement(Cart, null), /*#__PURE__*/ React__default.createElement(Text, {
        className: "express-overview__implicit-terms"
    }, labels.implicitTerms), /*#__PURE__*/ React__default.createElement("div", {
        className: "express-overview__action"
    }, /*#__PURE__*/ React__default.createElement(PaypalOrderButton, {
        isLoading: isUpdating,
        onClick: onNextClick,
        disabled: false
    })));
};

export { ExpressOverview };
//# sourceMappingURL=ExpressOverview.js.map
